import React from 'react';

function DarkFaqCommunity(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      width={52}
      height={52}
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect width={52} height={52} rx={4} fill='#5B316D' />
      <mask
        id='mask0_10148_43223'
        style={{
          maskType: 'alpha'
        }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={10}
        width={32}
        height={32}
      >
        <rect x={10} y={10} width={32} height={32} fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_10148_43223)'>
        <path
          d='M35.5332 24.4922C38.2977 24.4923 40.5595 26.6883 40.5596 29.3721V32.1221C40.5595 34.7142 38.3749 36.8347 35.7051 36.835L35.6846 36.8613L35.6387 39.0684C35.6354 39.2175 35.447 39.2875 35.3418 39.1787L33.1221 36.8877C33.0898 36.8542 33.0444 36.835 32.9971 36.835H28.2393C25.4747 36.8349 23.2129 34.6389 23.2129 31.9551V29.3721C23.2129 26.6883 25.4747 24.4923 28.2393 24.4922H35.5332ZM27.3633 28.8105C26.6105 28.8105 26 29.4257 26 30.1846C26 30.9434 26.6105 31.5586 27.3633 31.5586C28.1159 31.5584 28.7256 30.9433 28.7256 30.1846C28.7256 29.4258 28.1159 28.8107 27.3633 28.8105ZM31.9727 28.8105C31.2199 28.8105 30.6094 29.4257 30.6094 30.1846C30.6094 30.9434 31.2199 31.5586 31.9727 31.5586C32.7253 31.5584 33.335 30.9433 33.335 30.1846C33.335 29.4258 32.7253 28.8107 31.9727 28.8105ZM36.6367 28.8105C35.884 28.8105 35.2734 29.4257 35.2734 30.1846C35.2734 30.9434 35.884 31.5586 36.6367 31.5586C37.3893 31.5584 37.999 30.9433 37.999 30.1846C37.999 29.4258 37.3893 28.8107 36.6367 28.8105Z'
          fill='#C299C5'
        />
        <path
          d='M26.168 14.8086C29.3471 14.8086 31.9481 17.4308 31.9482 20.6357V23.5088H27.7061C24.678 23.5088 22.2004 26.0414 22.2002 29.1367V29.5479L20.6963 29.5488C20.642 29.5489 20.5899 29.5716 20.5527 29.6113L18 32.3477C17.8788 32.4771 17.6627 32.3929 17.6592 32.2148L17.6064 29.5791L17.583 29.5479C14.5125 29.5477 12.0001 27.0156 12 23.9199V20.6357C12.0002 17.4309 14.6012 14.8087 17.7803 14.8086H26.168ZM17.3633 19.8086C16.6105 19.8086 16 20.4238 16 21.1826C16 21.9415 16.6105 22.5566 17.3633 22.5566C18.1159 22.5565 18.7256 21.9414 18.7256 21.1826C18.7256 20.4239 18.1159 19.8088 17.3633 19.8086ZM21.9727 19.8086C21.2199 19.8086 20.6094 20.4238 20.6094 21.1826C20.6094 21.9415 21.2199 22.5566 21.9727 22.5566C22.7253 22.5565 23.335 21.9414 23.335 21.1826C23.335 20.4239 22.7253 19.8088 21.9727 19.8086ZM26.6367 19.8086C25.884 19.8086 25.2734 20.4238 25.2734 21.1826C25.2734 21.9415 25.884 22.5566 26.6367 22.5566C27.3893 22.5565 27.999 21.9414 27.999 21.1826C27.999 20.4239 27.3893 19.8088 26.6367 19.8086Z'
          fill='#C299C5'
        />
      </g>
    </svg>
  );
}

DarkFaqCommunity.displayName = 'DarkFaqCommunity';

export default DarkFaqCommunity;
